import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import asyncComponent from "../../../util/asyncComponent";

const Form = ({ match }) => (
  <Switch>
    <Redirect exact from={`${match.url}/`} to={`${match.url}/prensa`} />

    <Route
      path={`${match.url}/list-prensa`}
      component={asyncComponent(() => import("./routes/list-prensa"))}
    />

    <Route
      component={asyncComponent(() =>
        import("app/routes/extraPages/routes/404")
      )}
    />
  </Switch>
);

export default Form;



// WEBPACK FOOTER //
// ./app/routes/prensa/index.js